import type { PortableTextTypeComponent } from '@portabletext/react';

import BaseCallout, { BaseCalloutHtml } from './BaseCallout';

interface Props {
  _type: 'textCallout';
  text: string;
}

const TextCallout: PortableTextTypeComponent<Props> = ({
  value: { text = '' } = {},
}) => {
  return <BaseCallout text={text} />;
};

export default TextCallout;

export const TextCalloutHtml: PortableTextTypeComponent<Props> = ({
  value: { text = '' } = {},
}) => {
  return <BaseCalloutHtml text={text} />;
};
